const authTokenKey = `auth_token`;
export const getAuthToken = (): string | boolean => {
  const token = localStorage.getItem(authTokenKey);
  if (token) {
    return token;
  }
  return false;
};

export const setAuthToken = (token: string) => {
  localStorage.setItem(authTokenKey, token);
};
